import { useState } from 'react'
import { thumbnailUrl, type FsEntry, type ThumbnailTicket } from '../api'
import { hasThumbnail } from '../preview'
import { FileIcon, FolderIcon } from './icons'

/**
 * 무엇이 든 것인지 보여주는 그림.
 *
 * 그림 파일이면 썸네일을, 아니면 아이콘을 보여준다. 허브가 못 만드는 형식(HEIC 등)은
 * 여기서 미리 알 수 없으므로, 실패하면 그때 아이콘으로 되돌아간다 — 못 만든다는 답은
 * 허브가 기억하므로 다시 물어도 값이 싸다.
 *
 * 줄 앞의 20px 짜리와 격자의 큰 타일이 같은 것을 쓴다. 다른 것은 크기뿐인데, 그 하나
 * 때문에 갈라두면 "왜 격자에서만 아이콘이 뜨지" 같은 것이 한쪽에서만 고쳐진다.
 */
export default function EntryIcon({
  entry,
  ticket,
  size = 'row',
}: {
  entry: FsEntry
  ticket: ThumbnailTicket | null
  size?: 'row' | 'tile'
}) {
  const [failed, setFailed] = useState(false)
  const tile = size === 'tile'

  if (entry.type === 'dir') return <FolderIcon size={tile ? 64 : 20} />
  if (!ticket || failed || !hasThumbnail(entry.name)) {
    return <FileIcon name={entry.name} size={tile ? 64 : 20} />
  }

  return (
    <img
      className={tile ? 'tile-thumb' : 'thumb'}
      src={thumbnailUrl(ticket, entry.name)}
      alt=""
      loading="lazy"
      onError={() => setFailed(true)}
    />
  )
}
